import React from 'react';
import { SectionTitle } from '@apps/components/SectionTitle';
import CarListingSection from '@apps/containers/CarListing';
import { useGetResponsive } from '@stack/helpers/lib/responsive';
import useTranslation from 'next-translate/useTranslation';

import CarLaunchMonthSectionContentProps from './props';
import {
  Error404Caption,
  Error404CaptionWrapper,
  Error404Container,
  Error404Title,
} from './styles';

export const CarLaunchMonthSectionContent: React.FC<
  CarLaunchMonthSectionContentProps
> = (props) => {
  // ======================= VARIABLES
  const { sectionsData, sectionRef, webView } = props;

  // ======================= HOOKS
  const { t } = useTranslation('common');
  const { isWeb } = useGetResponsive();

  // ======================= RENDERERS

  const renderError404 = () => {
    return (
      <Error404Container
        style={{
          textDecoration: 'none',
        }}
      >
        <div
          style={{
            top: '20%',
            width: '100%',
            position: 'absolute',
          }}
        >
          <Error404Title>404</Error404Title>
          <Error404CaptionWrapper>
            <Error404Caption>{t('404caption')}</Error404Caption>
          </Error404CaptionWrapper>
        </div>
      </Error404Container>
    );
  };

  if (!sectionsData) return renderError404();
  return (
    <div>
      {sectionsData.map((section) => {
        return (
          <section
            key={`${section.key}`}
            id={`carLaunchMonthSection_${section.key}`}
            ref={(el) => (sectionRef[section.key] = el)}
          >
            <SectionTitle title={section.title} />

            {section.data && section.data.length > 0 ? (
              <CarListingSection
                webView={webView}
                cars={section.data}
                imageWrapperProps={
                  isWeb ? { width: '90%', height: '100%' } : undefined
                }
                nameProps={{
                  sx: {
                    maxWidth: isWeb ? '80%' : undefined,
                    margin: 'auto',
                  },
                }}
              />
            ) : (
              <div style={{ paddingBottom: 20 }}>
                <p>No car found.</p>
              </div>
            )}
          </section>
        );
      })}
    </div>
  );
};
